var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-link-button"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.link}},[_vm._v("\n\t\t詳しくみる\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }